import { type SxProps, type Theme } from '@mui/material';
import { gridClasses } from '@mui/x-data-grid-premium';

export const FILE_GRID_SKELETON_SLOT_PROPS = {
  loadingOverlay: {
    variant: 'skeleton',
    noRowsVariant: 'skeleton',
  },
} as const;

export const FILE_GRID_SX: SxProps<Theme> = {
  borderRadius: 0,
  backgroundColor: 'white.main',
  [`& .${gridClasses.cell}:focus, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.columnHeader}:focus-within`]:
    {
      outline: 'none',
    },
  [`& .${gridClasses.cell}.file-cell`]: {
    cursor: 'pointer',
  },
};

export const FILE_UPLOAD_STICKY_SX: SxProps<Theme> = [
  {
    p: 1,
  },
  theme => ({
    position: 'sticky',
    top: 0,
    left: 0,
    zIndex: 1,
    backgroundColor: (theme.vars ?? theme).palette.subMenu,
  }),
];
